import { makeStyles } from "@material-ui/core";

export const ChargeCalculationStyle = makeStyles((theme) => ({
    statusItem: {
        padding: '0.5em 1em',
        cursor: 'pointer',
    },
    selectItem: {
        padding: '0.5em 0',
        fontWeight: '500',
        '&.filled': {
            paddingLeft: '0.5em'
        }
    },
    selectMenu: {
    },
    select: {
        fontSize: '1em',
        padding: 0,
        borderRadius: 0,
        '& fieldset': {
            border: 'none'
        },
    },
    calculateButton: {
        margin: '1rem 0'
    }
}));